import { TypeInteractionResult, TypeInteraction, RequestResult } from "domain/entities/type-interaction";
import { Result } from "domain/entities/result";
import { TypeInteractionRepository } from "domain/repositories";
import Base from "data/base";

export class TypeInteractionApi implements TypeInteractionRepository {
    
    private static async rute(): Promise<string> {
        const res = await Base.getConfig();
        return res.DDI_API_URL + "/api/v1/interactions/effect";
    }

    /**
     * Obtiene todas los efectos de medicamentos de interacciones
     * @param token
     * @returns retorna un array con los efectos
     */
    async getAllTypeInteraction(token: string): Promise<[TypeInteractionResult[], null] | [null, Error]> {
        try {
            const url: string = await TypeInteractionApi.rute() + "/";
            
            const [res, error] = await Base.getArray(url, TypeInteractionResult, token);
            if (res === null && error !== null) return [null, error];
            if (res !== null) return [res, null];

            return [null, new Error("Error desconocido")]

        } catch (e) {
            return [null, e];
        }
    }

    /**
     * Obtiene un efecto de medicamento de interacción por su ID
     * @param id 
     * @returns retorna efecto
     */
    async getTypeInteraction(id: number): Promise<[null, Error] | [TypeInteractionResult, null]> {
        try {
            const url: string = await TypeInteractionApi.rute() + "/" + id;
                
            const [res, error] = await Base.get(url, TypeInteractionResult);
            if (res === null && error !== null) return [null, error];
            if (res !== null) return [res, null];
    
            return [null, new Error("Error desconocido")]
        } catch (e) {
            return [null, e];
        }
    }

    /**
     * Crea un efecto de medicamento de interacción
     * @param typeInteraction 
     * @param token 
     * @returns Retorna el resultado de la creación
     */
    async createTypeInteraction(typeInteraction: TypeInteraction, token: string): Promise<[null, Error] | [RequestResult, null]> {
        try {
            const url: string = await TypeInteractionApi.rute() + "/";
            const [res, error] = await Base.post(url, {
                dti_name: typeInteraction.name,
                dti_description: typeInteraction.description,
            }, RequestResult, token);
            if (res === null && error !== null) return [null, error];
            if (res !== null) return [res, null];

            return [null, new Error("Error desconocido")]
        } catch (e) {
            return [null, e];
        }
    }

    /**
     * Actualiza un efecto de medicamento de interacción
     * @param id 
     * @param typeInteraction 
     * @param token 
     * @returns Retorna el resultado de la actualización 
     */
    async updateTypeInteraction(id: number, typeInteraction: TypeInteraction, token: string): Promise<[null, Error] | [Result, null]> {
        try {
            const url: string = await TypeInteractionApi.rute() + "/" + id;
            const [res, error] = await Base.put(url, {
                dti_name: typeInteraction.name,
                dti_description: typeInteraction.description,
            }, Result, token);
            if (res === null && error !== null) return [null, error];
            if (res !== null) return [res, null];

            return [null, new Error("Error desconocido")]
        } catch (e) {
            return [null, e];
        }
    }

    /**
     * Elimina un efecto de medicamento de interacción
     * @param id 
     * @param token 
     * @returns Retorna el resultado de la eliminación 
     */
    async deleteTypeInteraction(id: number, token: string): Promise<[null, Error] | [Result, null]> {
        try {
            const url: string = await TypeInteractionApi.rute() + "/" + id;
                
            const [res, error] = await Base.delete(url, Result, token);
            if (res === null && error !== null) return [null, error];
            if (res !== null) return [res, null];
    
            return [null, new Error("Error desconocido")]
        } catch (e) {
            return [null, e];
        }
    }
}